export function BootScreen() {
  return (
    <div
      aria-live="polite"
      aria-busy="true"
      className="grid min-h-screen place-items-center"
    >
      <p className="font-mono text-xs uppercase tracking-[0.18em] text-muted">
        Loading session…
      </p>
    </div>
  )
}
